import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { Icon, Typography } from 'shared/ui'
import { Button } from 'shared/ui/Button'
import { useUnifiedAgentContext } from 'pages/chatbot/ui/UnifiedAgent/context/unifiedAgentContext'
import { TestAgentMessages } from './TestAgentMessages'
import { TestAgentFooter } from './TestAgentFooter'
import styles from './styles.module.scss'

type ITestAgentProps = {
  isMobile?: boolean
}

export const TestAgent = observer(({ isMobile }: ITestAgentProps) => {
  const { testAgentStore, isChatLoading } = useUnifiedAgentContext()
  const { started, loading } = testAgentStore

  return (
    <div
      className={classNames(styles.container, {
        [styles.containerMobile]: isMobile,
      })}
    >
      <div className={styles.content}>
        <Typography variant='heading-md' ariaLabel='TestAgent' className={styles.title}>
          Test agent
        </Typography>
        <div className={styles.wrap}>
          <div className={styles.wrap__layer}>
            {!started ? (
              <>
                <div className={styles.emptyState}>
                  <Icon icon='messageStarCircle02' fontSize={35} />
                  <Typography variant='body-lg-medium' ariaLabel='TestAgentEmptyText'>
                    Test your agent with no credit usage
                  </Typography>
                </div>
                <Button
                  text='Start testing'
                  typeBtn='contained'
                  contained='primary'
                  className={styles.startBtn}
                  onClick={testAgentStore.handleStart}
                  disabled={loading || isChatLoading}
                  aria-label='TestAgentStart'
                />
              </>
            ) : (
              <>
                <TestAgentMessages />
                <TestAgentFooter />
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
})
